// login 和logout接口的响应data的to字段的可能取值
export const LOGIN_TO = {
    // 账号密码页面
    ACCOUNT_PASSWORD: 'p_account_password',
    // 手机验证码页面
    PHONE_CODE: 'p_phone_code',
    // 登录成功
    LOGIN_SUCCESS: 'p_login',
    // 错误信息
    ERROR: 'p_error',
    // 跳转回登录首页
    REDIRECT: 'p_redirect',
};

// LOGIN_TO === 'p_error'时, 返回的错误类型
export const LOGIN_ERROR_TYPE = {
    ACCESS_ERROR: 'error',
    NETWORK_FORBIDDEN: 'network_forbidden'
};

export const LOGOUT_TO = {
    // 注销成功
    LOGOUT_SUCCESS: 'p_logout',
};
